import _ from 'lodash'
import PropTypes from 'prop-types'
import React, { type FunctionComponent, Suspense } from 'react'
import { getSelectSearchResults } from '../../../common/utils'
import Field from '../../fields'
import { HighlightedSearchResult, Spinner } from '../../generic'

interface MedicationFormProps {
  fields: any
  formId: string
  medicationsList?: any[] | null
  type?: 'create' | 'edit'
}

const MedicationForm: FunctionComponent<MedicationFormProps> = ({
  fields,
  formId,
  medicationsList,
  type = 'create'
}) => {
  if (!fields) return null
  if (type === 'create' && !medicationsList)
    return <Spinner style={styles.spinner} />

  const getLoadOptions = _.debounce(
    (input: string, callback: (options: any[]) => void) => {
      // @ts-ignore
      getSelectSearchResults(input, medicationsList, callback)
    },
    WAIT_TIME
  )

  return (
    <div>
      {type === 'create' && (
        <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              defaultOptions={[]}
              formatOptionLabel={HighlightedSearchResult}
              formId={formId}
              isSearch
              keys="name"
              label="Medication"
              loadOptions={getLoadOptions}
              options={medicationsList}
              placeholders="Search..."
              required
              type="select"
              values={fields}
            />
          </Suspense>
        </div>
      )}
      <div style={styles.fieldContainer}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={formId}
            keys="doseageInstructions"
            label="Dosage Instructions"
            required
            type="text"
            values={fields}
          />
        </Suspense>
      </div>
      <div style={styles.fieldContainer}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={formId}
            keys="additionalInformation"
            label="Additional Information"
            type="textarea"
            values={fields}
          />
        </Suspense>
      </div>
      <div style={styles.fieldContainer}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={formId}
            keys="timing"
            label="Timing"
            options={TIMING_OPTIONS}
            required
            type="checkbox"
            values={fields}
          />
        </Suspense>
      </div>
      <Suspense fallback={<div>Loading...</div>}>
        <Field
          keys="controlledDrug"
          label="Controlled Drug"
          formId={formId}
          type="switch"
          values={fields}
        />
      </Suspense>
    </div>
  )
}

const WAIT_TIME = 500

const TIMING_OPTIONS = [
  { value: 'Breakfast' },
  { value: 'Lunch' },
  { value: 'Dinner' },
  { value: 'Bedtime' },
  { value: 'As required' }
]

const styles = {
  fieldContainer: {
    marginBottom: 20
  },
  spinner: {
    paddingTop: 20
  }
}

export default MedicationForm
